import React, { useEffect, useMemo, useCallback } from "react";
import { Container, Row, Col, Card, Badge, Button, Nav } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import web5 from "../img/hos.jpg";

const Hospital = () => {
  const navigate = useNavigate();

  // ===================== THEME =====================
  const theme = useMemo(
    () => ({
      bg: "#f6f8fb",
      surface: "#ffffff",
      ink: "#0f172a",
      slate: "#334155",
      muted: "#64748b",
      border: "#e5e7eb",
      navy: "#0b1220",
      accent: "#1d4ed8",
      accent2: "#0ea5e9",
      success: "#16a34a",
      shadow: "0 24px 48px rgba(2, 6, 23, 0.08)",
      shadowSoft: "0 12px 24px rgba(2, 6, 23, 0.06)",
    }),
    []
  );

  // ===================== CONFIG =====================
  const brand = useMemo(
    () => ({
      name: "EBS Software Solution",
      email: "info@ebssoftware.co.in",
      phoneTop: "+91 99320 13501",
      salesPhone: "+91 97337 2 1111",
      gst: "19AJAPM8399K1ZE",
      websiteUrl: "https://example.com", // ✅ change to your real website
      pageUrl: "https://example.com/hospital", // ✅ change to your live URL
    }),
    []
  );

  const product = useMemo(
    () => ({
      name: "WardMaster",
      tagline: "Hospital / Nursing Home Management System",
      description:
        "WardMaster is a Hospital Management Software for OPD/IPD, billing, accounting, pharmacy, lab, OT, inventory and TPA workflows. It helps hospitals streamline patient care, improve operations and maintain accurate records.",
      os: ["Windows", "Android (Optional)"],
    }),
    []
  );

  // ===================== CONTENT =====================
  const heroTags = useMemo(
    () => ["OPD / IPD", "Billing", "TPA", "Pharmacy", "Lab", "Inventory"],
    []
  );

  const trustStats = useMemo(
    () => [
      { label: "Best For", value: "Hospitals & Nursing Homes" },
      { label: "Departments", value: "OPD, IPD, OT, ER, Lab" },
      { label: "Billing", value: "Insurance / TPA Ready" },
      { label: "Optional", value: "Android Attendance" },
    ],
    []
  );

  // ✅ same meaning, improved formatting (your text preserved)
  const features = useMemo(
    () => [
      "WardMaster helps to Manage patient appointment, visiting records, doctor consultation information, doctor advices, medicine records, prescription, treatment and billing history etc... The most important activity in OPD is registration of patients, fix appointment, prescription, vitals entry, clinical history, pharmacy and pathology billing etc... Every patient who comes to the hospital is registered on a simple Registration Form that collects all of the patient's information and gives them a unique registration number. The front desk is connected to all important hospital departments and serves as the point of contact for patients' inquiries. Additionally, the front desk handles all aspects of billing.",
      "WardMaster helps to Manage patient appointment, visiting records, doctor consultation information, doctor advices, medicine records, prescription, treatment and billing history etc... All of this data will be recorded and printed by the Warmaster. IPD Billing Online billing for all IPD patients, including patient information, daily services like room rent, operations, deliveries, oxygen and other gases, consultations, nursing fees, laboratory tests, X-rays, ultrasounds, medications, and procedures, among other things. IPD Collection Collection of partial payments, full payments, refunds, and credit notes are all included. The data for all MIS reports will come from this information.",
      "With Hospital Management Software, You'll Never Have to Worry About Booking Patients, Scheduling appointments, & more! WardMaster TPA Management helps to Manage patient Billing, to claim insurance, and manage billing on the basis of TPA sanction amount. Provision to maintaining records of TPA and Insurance details.",
      "User Management : You can add, modify, and delete users as well as their specific rights using the Wardmaster. Moreover, in accordance with security procedures. enables you to immediately revoke a user's access in an emergency while maintaining their entire history. Management can check operational audit reports of the users.",
      "WardMaster offers a solution for the complete inventory management cycle starting from intend to purchase order, approvals and GRN with provisions for online material request and issues to facilitate paper less management of inventory making it a unique hospital erp system. Flexible grouping of items with multiple units and conversion factor combined with multiple store options ensure that you have precise control on the inventory. Vendor management, purchase invoice and accounts payable.",
      "WardMaster helps to Manage patient OPD, IPD, Daycare, Pharmacy, Lab, OT, Emergency and Department wise billing etc... By automating tasks that would otherwise be completed manually, hospital management system software can help improve efficiency and free up staff time for other tasks.(like discharge card, prescription, medical certificate, doctors reminders, advices and patient next visit reminders etc.)",
      "WardMaster offers a complete financial accounting includes cash/bank book, receivables and payables. And can generated reports upto final accounting.",
      "WardMaster helps to improve patient care by providing access to information about patient's medical history, medications and allergies. This information can help to ensure that patients receive the best possible care. The system is crucial for any hospital as it helps to streamline the process of patient care. It allows doctors and staff to keep track of appointments, medical records, and prescriptions. This module also made indent for medicine and also make schedule OT and various services which can operate from the Nursing station",
      "WardMaster helps to Manage patient appointment, patient treatment/advices, consultation information, doctor advices, medicine records, prescription, treatment and billing history etc... Maintain the medical records of the patient, Maintain the contact details of the patient, Keep track of the appointment dates, Save the insurance information for later reference, Tracking the bill payments.",
      "WardMaster Diagnosis/Laboratory Management Software is suitable for Diagnostics Centers, clinics and Hospital Labs. Diagnostics Test Rate Master, Investigation Master with Reference Values, Appointments, Test wise reports, Billing & Receipts, Centralized billing, Lab Report, Patient Registration, Package Master and Tests summary etc...",
      "WardMaster offers flexible and easily configurable features and facilities that makes it user-friendly and accurate. It is also linked with the financial accounting and other modules of WardMaster for effective financial control and user access control. You won’t need any complicated hardware for employess attendance. WardMaster runs an Android App face recognition attendance system, which provides practically 100% robust and accurate attendance.",
    ],
    []
  );

  // ===================== SEO (Meta + JSON-LD, NO Helmet) =====================
  const schemaMarkup = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          name: brand.name,
          url: brand.websiteUrl,
          email: brand.email,
          telephone: brand.phoneTop,
        },
        {
          "@type": "WebPage",
          "@id": brand.pageUrl,
          url: brand.pageUrl,
          name: `${product.name} | Hospital Management System | ${brand.name}`,
          description: product.description,
        },
        {
          "@type": "SoftwareApplication",
          name: product.name,
          applicationCategory: "BusinessApplication",
          operatingSystem: product.os,
          description: product.description,
          offers: {
            "@type": "Offer",
            priceCurrency: "INR",
            availability: "https://schema.org/InStock",
          },
          featureList: [
            "OPD & IPD Management",
            "Billing & Accounting",
            "TPA / Insurance Management",
            "Pharmacy & Pathology Billing",
            "Laboratory Management",
            "Inventory & Procurement",
            "OT / Emergency / Department Billing",
            "Android Face Recognition Attendance (Optional)",
          ],
          publisher: { "@type": "Organization", name: brand.name },
        },
      ],
    }),
    [brand, product]
  );

  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${product.name} | Hospital Management System | ${brand.name}`;

    const head = document.head;
    const cleanup = () => {
      head.querySelectorAll('[data-wardmaster="1"]').forEach((n) => n.remove());
    };
    cleanup();

    const addMeta = (attrs) => {
      const el = document.createElement("meta");
      Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
      el.setAttribute("data-wardmaster", "1");
      head.appendChild(el);
    };

    const addLink = (attrs) => {
      const el = document.createElement("link");
      Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
      el.setAttribute("data-wardmaster", "1");
      head.appendChild(el);
    };

    addLink({ rel: "canonical", href: brand.pageUrl });
    addMeta({ name: "description", content: product.description });

    addMeta({ property: "og:type", content: "website" });
    addMeta({ property: "og:title", content: `${product.name} | ${brand.name}` });
    addMeta({ property: "og:description", content: product.description });
    addMeta({ property: "og:url", content: brand.pageUrl });

    addMeta({ name: "twitter:card", content: "summary_large_image" });
    addMeta({ name: "twitter:title", content: `${product.name} | ${brand.name}` });
    addMeta({ name: "twitter:description", content: product.description });

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(schemaMarkup);
    script.setAttribute("data-wardmaster", "1");
    head.appendChild(script);

    return () => {
      cleanup();
      document.title = prevTitle;
    };
  }, [brand, product, schemaMarkup]);

  // ===================== HELPERS =====================
  const scrollToId = useCallback((id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  // ===================== STYLES =====================
  const styles = {
    page: {
      background: theme.bg,
      minHeight: "100vh",
      color: theme.slate,
      fontFamily: "'Inter', system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
    },

    topBar: {
      background: theme.navy,
      color: "#e2e8f0",
      fontSize: 13,
      borderBottom: "1px solid rgba(255,255,255,0.08)",
    },
    topBarInner: {
      padding: "8px 0",
      display: "flex",
      justifyContent: "space-between",
      gap: 12,
      flexWrap: "wrap",
      alignItems: "center",
    },
    topLink: { color: "#e2e8f0", textDecoration: "none", fontWeight: 800 },

    navWrap: {
      position: "sticky",
      top: 0,
      zIndex: 40,
      background: "rgba(246,248,251,0.9)",
      backdropFilter: "blur(12px)",
      borderBottom: `1px solid ${theme.border}`,
    },
    navInner: {
      padding: "14px 0",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 14,
      flexWrap: "wrap",
    },
    brandRow: { display: "flex", alignItems: "center", gap: 12 },
    logo: {
      width: 44,
      height: 44,
      borderRadius: 14,
      background: `linear-gradient(135deg, ${theme.accent}, ${theme.accent2})`,
      boxShadow: theme.shadowSoft,
      flexShrink: 0,
    },
    brandName: { margin: 0, fontWeight: 950, color: theme.ink, letterSpacing: -0.2, fontSize: 16 },
    brandSub: { margin: 0, color: theme.muted, fontWeight: 750, fontSize: 12 },

    hero: {
      marginTop: 18,
      borderRadius: 24,
      overflow: "hidden",
      position: "relative",
      background: theme.navy,
      boxShadow: theme.shadow,
      border: `1px solid ${theme.border}`,
    },
    heroImg: {
      width: "100%",
      height: 540,
      objectFit: "cover",
      opacity: 0.24,
      filter: "grayscale(100%) contrast(120%)",
      transform: "scale(1.02)",
    },
    heroOverlay: {
      position: "absolute",
      inset: 0,
      background:
        "radial-gradient(900px 600px at 18% 25%, rgba(29,78,216,0.35), transparent 60%), radial-gradient(900px 500px at 85% 15%, rgba(14,165,233,0.25), transparent 55%), linear-gradient(180deg, rgba(11,18,32,0.50), rgba(11,18,32,0.92))",
    },
    heroContent: {
      position: "absolute",
      inset: 0,
      padding: "clamp(18px, 4vw, 56px)",
      display: "flex",
      alignItems: "center",
    },
    pill: {
      display: "inline-flex",
      alignItems: "center",
      gap: 10,
      padding: "10px 14px",
      borderRadius: 999,
      background: "rgba(255,255,255,0.10)",
      border: "1px solid rgba(255,255,255,0.18)",
      color: "#dbeafe",
      fontWeight: 900,
      textTransform: "uppercase",
      letterSpacing: 1,
      fontSize: 12,
      width: "fit-content",
    },
    h1: {
      marginTop: 14,
      marginBottom: 10,
      fontSize: "clamp(2.2rem, 4.2vw, 3.6rem)",
      fontWeight: 950,
      color: "#fff",
      letterSpacing: -0.8,
      lineHeight: 1.05,
      textShadow: "0 10px 30px rgba(0,0,0,0.35)",
    },
    heroP: {
      color: "#e2e8f0",
      lineHeight: 1.9,
      fontSize: 16,
      maxWidth: 700,
      marginBottom: 18,
    },
    tagRow: { display: "flex", gap: 10, flexWrap: "wrap", marginTop: 12 },
    tag: {
      padding: "8px 12px",
      borderRadius: 999,
      color: "#e2e8f0",
      background: "rgba(255,255,255,0.10)",
      border: "1px solid rgba(255,255,255,0.18)",
      fontWeight: 850,
      fontSize: 13,
    },
    heroCard: {
      background: "rgba(255,255,255,0.97)",
      borderRadius: 18,
      border: "1px solid rgba(255,255,255,0.60)",
      boxShadow: "0 30px 70px rgba(2,6,23,0.25)",
    },
    statGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginTop: 14 },
    stat: { border: `1px solid ${theme.border}`, borderRadius: 14, padding: 12, background: theme.surface },
    statLabel: { margin: 0, fontSize: 12, color: theme.muted, fontWeight: 850 },
    statValue: { margin: "6px 0 0 0", fontSize: 14, color: theme.ink, fontWeight: 950, lineHeight: 1.35 },

    section: { padding: "56px 0" },
    sectionTitle: { margin: 0, fontSize: 28, fontWeight: 950, color: theme.ink, letterSpacing: -0.4 },
    sectionSub: { marginTop: 10, marginBottom: 0, color: theme.muted, lineHeight: 1.85, maxWidth: 900 },

    featureCard: {
      height: "100%",
      borderRadius: 18,
      border: `1px solid ${theme.border}`,
      background: theme.surface,
      boxShadow: theme.shadowSoft,
      padding: 18,
    },
    featureTitle: { margin: 0, fontSize: 16, fontWeight: 950, color: theme.ink, letterSpacing: -0.2 },
    featureDesc: { margin: "8px 0 0 0", color: theme.muted, lineHeight: 1.8, fontSize: 14 },

    cta: {
      borderRadius: 26,
      background: theme.navy,
      color: "#fff",
      position: "relative",
      overflow: "hidden",
      boxShadow: theme.shadow,
      border: "1px solid rgba(255,255,255,0.12)",
      marginTop: 8,
    },
    ctaOverlay: {
      position: "absolute",
      inset: 0,
      background:
        "radial-gradient(900px 500px at 20% 30%, rgba(29,78,216,0.45), transparent 60%), radial-gradient(800px 450px at 80% 20%, rgba(14,165,233,0.30), transparent 55%), linear-gradient(180deg, rgba(11,18,32,0.35), rgba(11,18,32,0.92))",
    },
    ctaBody: {
      position: "relative",
      padding: "30px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 16,
      flexWrap: "wrap",
    },
    ctaTitle: {
      margin: 0,
      fontWeight: 950,
      letterSpacing: -0.4,
      color: "#ffffff",
      fontSize: "clamp(1.4rem, 2.2vw, 2rem)",
      textShadow: "0 10px 26px rgba(0,0,0,0.35)",
    },
    ctaText: { margin: "10px 0 0 0", color: "#dbeafe", lineHeight: 1.85, fontSize: 15, maxWidth: 760 },
    footer: { padding: "26px 0 40px", color: theme.muted, fontSize: 13 },
  };

  return (
    <div style={styles.page}>
      {/* Top bar */}
      <div style={styles.topBar}>
        <Container>
          <div style={styles.topBarInner}>
            <div className="d-flex gap-3 flex-wrap">
              <span>
                Email:{" "}
                <a style={styles.topLink} href={`mailto:${brand.email}`}>
                  {brand.email}
                </a>
              </span>
              <span>
                Sales:{" "}
                <a style={styles.topLink} href={`tel:${brand.salesPhone.replace(/\s/g, "")}`}>
                  {brand.salesPhone}
                </a>
              </span>
            </div>
            <div style={{ fontWeight: 900 }}>GSTIN: {brand.gst}</div>
          </div>
        </Container>
      </div>

      {/* Local product nav */}
      <div style={styles.navWrap}>
        <Container>
          <div style={styles.navInner}>
            <div style={styles.brandRow}>
              <div style={styles.logo} aria-hidden="true" />
              <div>
                <p style={styles.brandName}>{product.name}</p>
                <p style={styles.brandSub}>{product.tagline}</p>
              </div>
            </div>

            <Nav className="d-none d-md-flex" style={{ gap: 14 }}>
              <Nav.Link onClick={() => scrollToId("overview")} style={{ color: theme.slate, fontWeight: 850 }}>
                Overview
              </Nav.Link>
              <Nav.Link onClick={() => scrollToId("features")} style={{ color: theme.slate, fontWeight: 850 }}>
                Features
              </Nav.Link>
              <Nav.Link onClick={() => scrollToId("contact")} style={{ color: theme.slate, fontWeight: 850 }}>
                Contact
              </Nav.Link>
            </Nav>

            <div className="d-flex gap-2 flex-wrap">
              <Button
                variant="outline-primary"
                style={{ borderRadius: 12, fontWeight: 900 }}
                onClick={() => navigate("/request-demo")}
              >
                Request Demo
              </Button>
              <Button
                variant="primary"
                style={{ borderRadius: 12, fontWeight: 950, background: theme.accent, borderColor: theme.accent }}
                onClick={() => navigate("/contact-sales")}
              >
                Contact Sales
              </Button>
            </div>
          </div>
        </Container>
      </div>

      <Container>
        {/* HERO */}
        <div style={styles.hero}>
          <img src={web5} alt="Hospital management system banner" style={styles.heroImg} />
          <div style={styles.heroOverlay} />

          <div style={styles.heroContent}>
            <Row className="w-100 g-4 align-items-center">
              <Col lg={7}>
                <div style={styles.pill}>HEALTHCARE • HOSPITAL MANAGEMENT</div>
                <h1 style={styles.h1}>{product.name}</h1>
                <p style={styles.heroP}>{product.description}</p>

                <div className="d-flex gap-2 flex-wrap">
                  <Button
                    variant="primary"
                    style={{ borderRadius: 12, fontWeight: 950, background: theme.accent2, borderColor: theme.accent2 }}
                    onClick={() => navigate("/request-demo")}
                  >
                    Book a Demo
                  </Button>
                  <Button variant="light" style={{ borderRadius: 12, fontWeight: 950 }} onClick={() => scrollToId("features")}>
                    View Features
                  </Button>

                  <Badge bg="light" text="dark" style={{ borderRadius: 999, padding: "10px 12px", fontWeight: 900 }}>
                    TPA / Insurance Ready
                  </Badge>
                </div>

                <div style={styles.tagRow}>
                  {heroTags.map((t) => (
                    <span key={t} style={styles.tag}>
                      {t}
                    </span>
                  ))}
                </div>
              </Col>

              <Col lg={5}>
                <Card style={styles.heroCard}>
                  <Card.Body style={{ padding: 18 }}>
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <div style={{ fontWeight: 950, color: theme.ink, fontSize: 15 }}>Executive Snapshot</div>
                        <div style={{ color: theme.muted, fontWeight: 750, fontSize: 12, marginTop: 6 }}>
                          Workflow-focused hospital ERP
                        </div>
                      </div>
                      <Badge bg="primary" style={{ borderRadius: 999, fontWeight: 900 }}>
                        WardMaster
                      </Badge>
                    </div>

                    <div style={styles.statGrid}>
                      {trustStats.map((s) => (
                        <div key={s.label} style={styles.stat}>
                          <p style={styles.statLabel}>{s.label}</p>
                          <p style={styles.statValue}>{s.value}</p>
                        </div>
                      ))}
                    </div>

                    <div style={{ marginTop: 12, color: theme.muted, fontSize: 13, lineHeight: 1.7 }}>
                      <b style={{ color: theme.ink }}>Sales:</b>{" "}
                      <a href={`tel:${brand.salesPhone.replace(/\s/g, "")}`} style={{ textDecoration: "none" }}>
                        {brand.salesPhone}
                      </a>
                      <br />
                      Implementation, training & support available.
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        </div>

        {/* OVERVIEW */}
        <section id="overview" style={styles.section}>
          <Row className="g-4 align-items-start">
            <Col lg={5}>
              <h2 style={styles.sectionTitle}>Overview</h2>
              <p style={styles.sectionSub}>
                WardMaster helps hospitals manage OPD/IPD records, appointments, billing, lab and pharmacy workflows, wards, OT and discharge documentation.
                It also supports financial accounting and insurance/TPA processes.
              </p>
            </Col>

            <Col lg={7}>
              <Card style={{ borderRadius: 18, border: `1px solid ${theme.border}`, boxShadow: theme.shadowSoft }}>
                <Card.Body style={{ padding: 18 }}>
                  <div style={{ fontWeight: 950, color: theme.ink, fontSize: 16 }}>Department Coverage</div>
                  <div style={{ marginTop: 6, color: theme.muted, lineHeight: 1.7 }}>
                    OPD, IPD, Emergency, Daycare, Pharmacy, Lab, OT and department-wise billing with MIS reporting.
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </section>

        {/* FEATURES */}
        <section id="features" style={{ ...styles.section, paddingTop: 0 }}>
          <Row className="mb-3">
            <Col lg={8}>
              <h2 style={styles.sectionTitle}>Key Features</h2>
              <p style={styles.sectionSub}>
                Detailed feature set built for real hospital operations. (Your original content preserved, only presented in a corporate format.)
              </p>
            </Col>
          </Row>

          <Row className="g-3">
            {features.map((text, idx) => (
              <Col key={idx} md={6}>
                <div style={styles.featureCard}>
                  <div className="d-flex align-items-start gap-3">
                    <div
                      style={{
                        width: 34,
                        height: 34,
                        borderRadius: 10,
                        background: "#eef2ff",
                        border: `1px solid ${theme.border}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 950,
                        color: theme.accent,
                        flexShrink: 0,
                      }}
                    >
                      {idx + 1}
                    </div>
                    <div>
                      <h3 style={{ ...styles.featureTitle, marginBottom: 8 }}>Module {idx + 1}</h3>
                      <p style={{ margin: 0, color: theme.muted, lineHeight: 1.85, fontSize: 14 }}>{text}</p>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </section>

        {/* CTA */}
        <section id="contact" style={{ paddingBottom: 56 }}>
          <div style={styles.cta}>
            <div style={styles.ctaOverlay} />
            <div style={styles.ctaBody}>
              <div>
                <h2 style={styles.ctaTitle}>Need a WardMaster demo for your hospital?</h2>
                <p style={styles.ctaText}>
                  Call sales at{" "}
                  <a
                    href={`tel:${brand.salesPhone.replace(/\s/g, "")}`}
                    style={{ color: "#fff", fontWeight: 900, textDecoration: "underline" }}
                  >
                    {brand.salesPhone}
                  </a>{" "}
                  or submit a demo request.
                </p>
              </div>

              <div className="d-flex gap-2 flex-wrap">
                <Button variant="light" style={{ borderRadius: 12, fontWeight: 950 }} onClick={() => navigate("/request-demo")}>
                  Request Demo
                </Button>
                <Button
                  variant="primary"
                  style={{ borderRadius: 12, fontWeight: 950, background: theme.accent2, borderColor: theme.accent2 }}
                  onClick={() => navigate("/contact-sales")}
                >
                  Contact Sales
                </Button>
              </div>
            </div>
          </div>

          <div style={styles.footer}>
            © {new Date().getFullYear()} {brand.name}. All rights reserved.
          </div>
        </section>
      </Container>
    </div>
  );
};

export default Hospital;
